import React from "react";
import "./BottomServiceBanner.css";
import {Link } from "react-router-dom";


const BottomServiceBanner = () => {
  return (
    <div className="bottom-service-banner">
      <div className="bottom-service-banner-container">
        <div className="bottom-service-banner-container-inner">
          <h1 className="bottom-service-banner-container-title">
            NOT SURE WHERE TO START?
          </h1>
          <h5 className="bottom-service-banner-container-subtitle">
            We can help you to discover your next steps with Lincourt Pharmacy!
          </h5>
          <Link to="/contact" className="bottom-service-banner-container-btn">
            GET IN TOUCH
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BottomServiceBanner;
